import React from "react";
import { connect } from 'react-redux';
import classnames from "classnames";
import moment from "moment";
import ReactDatetime from "react-datetime";
import ClipLoader from "react-spinners/ClipLoader";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Badge, Table, Modal, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Nav, NavItem, NavLink, TabContent, TabPane, Alert } from "reactstrap";
import SimpleHeader from "./../../components/Headers/SimpleHeader.jsx";
import api from "./../../Api.js";

//nomes dos dias na convenção do JS/moment (0 = domingo)
const diasNome = { 0: "Domingo", 1: "Segunda", 2: "Terça", 3: "Quarta", 4: "Quinta", 5: "Sexta", 6: "Sábado" };

const statusColor = { planejada: "info", realizada: "success", cancelada: "danger", remarcada: "warning" };

class Cronograma extends React.Component {

    constructor(props){

        super(props);

        this.state = {

            tab: "1",
            classrooms: [],
            classroom: "",
            classRoomData: undefined,
            schedules: [],
            loadClassrooms: false,
            loadSchedules: false,

            openModalGenerate: false,
            dialogGenerate: { lessons: "", startDate: "" },
            erroGenerate: "",
            generating: false,

            openModalPlan: false,
            dialogPlan: {},
            erroPlan: "",

            openModalReschedule: false,
            dialogReschedule: { date: "", cascade: true },
            reschedule: undefined,
            erroReschedule: "",

            //ids das aulas marcadas para remoção em lote
            selected: [],
            deleting: false,

            weekStart: moment().day(1).format('YYYY-MM-DD'),
            weekSchedules: [],
            loadWeek: false

        };

        this.getClassrooms = this.getClassrooms.bind(this);
        this.getCronograma = this.getCronograma.bind(this);
        this.generateCronograma = this.generateCronograma.bind(this);
        this.savePlan = this.savePlan.bind(this);
        this.saveReschedule = this.saveReschedule.bind(this);
        this.getWeek = this.getWeek.bind(this);
        this.toggleSelected = this.toggleSelected.bind(this);
        this.toggleSelectedAll = this.toggleSelectedAll.bind(this);
        this.deleteSelected = this.deleteSelected.bind(this);

        //identifica a última busca de turmas disparada, para descartar respostas atrasadas
        this.classroomsRequest = 0;

        window.cronograma = this;

    }

    componentDidMount(){

        //quem chega navegando pelo menu já tem o usuário carregado; quem abre a página direto
        //na URL espera o App.js popular, e a busca acontece no componentDidUpdate
        if(this.userCarregado()){ this.getClassrooms(); }

    }

    //A permissão e a unidade do usuário chegam de forma assíncrona (App.js popula depois do
    //mount), então a lista de turmas é buscada quando elas mudam. Sem isso, um gestor que
    //abre a página direto na URL veria apenas as próprias turmas em vez das turmas da unidade.
    componentDidUpdate(prevProps){

        var permissionAnterior = (prevProps.permission || []).length;
        var companyAnterior = (prevProps.user || {}).company;

        if(permissionAnterior !== (this.props.permission || []).length || companyAnterior !== (this.props.user || {}).company){

            this.getClassrooms();

        }

    }

    //O usuário logado chega inteiro de uma vez pelo SET_DATA_USER
    userCarregado(){

        return (this.props.user || {}).id !== undefined;

    }

    //Verifica se o usuário pode gerenciar o cronograma (a validação final é do backend)
    canManage(){

        if((this.props.permission || []).indexOf(15) !== -1){ return true; }

        var accessLevel = parseInt((this.props.user || {}).accessLevel);
        if(accessLevel === 3 || accessLevel === 5){ return true; }

        return false;

    }

    //Para listar as turmas que o usuário pode ver
    async getClassrooms(){

        var permission = this.props.permission || [];
        var company = (this.props.user || {}).company;
        var request;

        //a busca do mount e a disparada quando a unidade chega ficam as duas em voo; o token
        //garante que só a última aplique o resultado, senão a lista de turmas da unidade
        //pode ser sobrescrita pela resposta atrasada das turmas do próprio usuário
        var requestId = ++this.classroomsRequest;

        //só lista por unidade quando a unidade já chegou; senão cai nas turmas do usuário
        if((permission.indexOf(19) !== -1 || permission.indexOf(24) !== -1) && company !== undefined){

            request = api.getAllClassRoomCompany(company);

        }else{

            request = api.getMyClassRooms();

        }

        await request.then((res) => {

            if(requestId !== this.classroomsRequest){ return false; }

            var classrooms = Array.isArray(res.data) ? res.data : [];
            this.setState({ classrooms: classrooms, loadClassrooms: true });

        }).catch(error => {

            console.log(error);
            if(requestId !== this.classroomsRequest){ return false; }
            this.setState({ loadClassrooms: true });

        });

    }

    //Para pegar o cronograma da turma selecionada
    async getCronograma(classroom){

        if(classroom === "" || classroom === undefined){ this.setState({ classroom: "", classRoomData: undefined, schedules: [], selected: [] }); return false; }

        //a seleção é sempre zerada: os ids marcados valem só para a lista carregada
        this.setState({ classroom: classroom, loadSchedules: false, selected: [] });

        await api.getCronogramaClassroom(classroom).then((res) => {

            this.setState({ classRoomData: res.data.classRoom, schedules: res.data.schedules, loadSchedules: true });

        }).catch(error => {

            console.log(error);
            this.setState({ loadSchedules: true, schedules: [] });
            if(error.response !== undefined && error.response.data !== undefined){ window.swal.fire('Ops!', error.response.data.msg, 'error'); }

        });

    }

    //Para gerar (ou regerar) o cronograma da turma
    async generateCronograma(event, replace){

        if(event !== undefined){ event.preventDefault(); }

        var data = { classRoom: this.state.classroom, lessons: this.state.dialogGenerate.lessons };
        if(this.state.dialogGenerate.startDate !== ""){ data.startDate = this.state.dialogGenerate.startDate; }
        if(replace === true){ data.replace = true; }

        this.setState({ generating: true, erroGenerate: "" });

        await api.generateCronograma(data).then((res) => {

            this.setState({ generating: false, openModalGenerate: false, schedules: res.data.schedules, loadSchedules: true });
            window.swal.fire(this.props.translate['sucesso'] || 'Sucesso!', res.data.msg, 'success');

        }).catch(async (error) => {

            console.log(error);
            this.setState({ generating: false });

            if(error.response !== undefined && error.response.status === 409){

                var result = await window.swal.fire({
                    title: this.props.translate['regerar_cronograma'] || 'Regerar cronograma?',
                    text: error.response.data.msg + ' As aulas realizadas, canceladas e remarcadas são mantidas; só as planejadas são regeradas.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: this.props.translate['regerar'] || 'Regerar',
                    cancelButtonText: this.props.translate['cancelar'] || 'Cancelar'
                });

                if(result.isConfirmed){ this.generateCronograma(undefined, true); }
                return false;

            }

            if(error.response !== undefined && error.response.data !== undefined){ this.setState({ erroGenerate: error.response.data.msg }); }

        });

    }

    //Para salvar o plano de aula / status
    async savePlan(event){

        event.preventDefault();

        var dialog = this.state.dialogPlan;
        var data = { name: dialog.name, status: dialog.status, objective: dialog.objective, tool: dialog.tool, project: dialog.project, activities: dialog.activities, homework: dialog.homework, familySummary: dialog.familySummary, notes: dialog.notes };

        await api.putCronograma(dialog.id, data).then((res) => {

            this.setState({ openModalPlan: false, erroPlan: "" });
            this.getCronograma(this.state.classroom);

        }).catch(error => {

            console.log(error);
            if(error.response !== undefined && error.response.data !== undefined){ this.setState({ erroPlan: error.response.data.msg }); }

        });

    }

    //Para remarcar uma aula
    async saveReschedule(event){

        event.preventDefault();

        var data = { date: this.state.dialogReschedule.date, cascade: this.state.dialogReschedule.cascade };

        await api.rescheduleCronograma(this.state.reschedule.id, data).then((res) => {

            this.setState({ openModalReschedule: false, erroReschedule: "" });
            this.getCronograma(this.state.classroom);
            window.swal.fire(this.props.translate['sucesso'] || 'Sucesso!', res.data.msg, 'success');

        }).catch(error => {

            console.log(error);
            if(error.response !== undefined && error.response.data !== undefined){ this.setState({ erroReschedule: error.response.data.msg }); }

        });

    }

    //Marca ou desmarca uma aula da seleção
    toggleSelected(id){

        var selected = this.state.selected.slice();
        var index = selected.indexOf(id);

        if(index === -1){ selected.push(id); }else{ selected.splice(index,1); }

        this.setState({ selected: selected });

    }

    //Marca ou desmarca todas as aulas da turma
    toggleSelectedAll(){

        if(this.state.selected.length === this.state.schedules.length){

            this.setState({ selected: [] });

        }else{

            this.setState({ selected: this.state.schedules.map((schedule) => schedule.id) });

        }

    }

    //Remove as aulas selecionadas, avisando quando alguma já não é planejada
    async deleteSelected(){

        var total = this.state.selected.length;
        if(total === 0){ return false; }

        //o status já está carregado na tela, então o aviso é montado sem ida ao servidor
        var notPlanned = this.state.schedules.filter((schedule) => {

            return this.state.selected.indexOf(schedule.id) !== -1 && schedule.status !== "planejada";

        }).length;

        var text = (total === 1) ? "A aula selecionada será removida do cronograma." : "As " + total + " aulas selecionadas serão removidas do cronograma.";

        if(notPlanned > 0){

            if(total === 1){

                text += " Atenção: essa aula já não está planejada (realizada, cancelada ou remarcada) e o plano de aula será perdido.";

            }else if(notPlanned === 1){

                text += " Atenção: 1 delas já não está planejada (realizada, cancelada ou remarcada) e o plano de aula será perdido.";

            }else{

                text += " Atenção: " + notPlanned + " delas já não estão planejadas (realizadas, canceladas ou remarcadas) e os planos de aula serão perdidos.";

            }

        }

        var result = await window.swal.fire({
            title: (total === 1) ? (this.props.translate['remover_aula'] || 'Remover aula?') : (this.props.translate['remover_aulas'] || 'Remover aulas?'),
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this.props.translate['remover'] || 'Remover',
            cancelButtonText: this.props.translate['cancelar'] || 'Cancelar'
        });

        if(!result.isConfirmed){ return false; }

        this.setState({ deleting: true });

        await api.deleteCronograma({ classRoom: this.state.classroom, ids: this.state.selected }).then((res) => {

            this.setState({ deleting: false, selected: [], schedules: res.data.schedules });
            window.swal.fire(this.props.translate['sucesso'] || 'Sucesso!', res.data.msg, 'success');

        }).catch(error => {

            console.log(error);
            this.setState({ deleting: false });
            if(error.response !== undefined && error.response.data !== undefined){ window.swal.fire('Ops!', error.response.data.msg, 'error'); }

        });

    }

    //Para pegar as aulas da semana
    async getWeek(start){

        this.setState({ weekStart: start, loadWeek: false });

        await api.getCronogramaWeek(start).then((res) => {

            this.setState({ weekSchedules: res.data, loadWeek: true });

        }).catch(error => { console.log(error); this.setState({ loadWeek: true, weekSchedules: [] }); });

    }

    //Monta a mensagem pronta para as famílias e copia
    copyFamilyMessage(schedule){

        var msg = "📅 " + (schedule.classRoomName || "") + " — " + moment(schedule.date, 'YYYY-MM-DD').format('DD/MM') + " às " + String(schedule.start_time).substring(0, 5) + " (" + schedule.name + ")";
        if(schedule.familySummary !== null && schedule.familySummary !== undefined && schedule.familySummary !== ""){ msg += " — " + schedule.familySummary; }

        try {

            navigator.clipboard.writeText(msg);
            window.swal.fire(this.props.translate['mensagem_copiada'] || 'Mensagem copiada!', msg, 'success');

        }catch(error){ window.swal.fire('Ops!', msg, 'info'); }

    }

    render(){

        const translate = this.props.translate;
        const canManage = this.canManage();

        const handleGenerate = name => event => {
            var dialog = this.state.dialogGenerate;
            dialog[name] = event.target.value;
            this.setState({ dialogGenerate: dialog });
        }

        const handlePlan = name => event => {
            var dialog = this.state.dialogPlan;
            dialog[name] = event.target.value;
            this.setState({ dialogPlan: dialog });
        }

        return(<React.Fragment>

            <SimpleHeader name={translate['cronograma'] || "Cronograma"} way={[{ name: translate['cronograma'] || "Cronograma", url: "/cronograma" }]} buttons={<React.Fragment></React.Fragment>} />

            <Container className="mt--6" fluid>

                <Card>

                    <CardHeader className="border-0">
                        <Row>
                            <Col xs="6"><h3 className="mb-0">{translate['cronograma_de_aulas'] || "Cronograma de aulas"}</h3></Col>
                        </Row>
                        <Nav className="nav-fill flex-column flex-sm-row mt-3" pills role="tablist">
                            <NavItem>
                                <NavLink className={classnames("mb-sm-3 mb-md-0", { active: this.state.tab === "1" })} onClick={() => this.setState({ tab: "1" })} role="tab" href="#" >
                                    <i className="fas fa-list-ol mr-2" />{translate['por_turma'] || "Por turma"}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames("mb-sm-3 mb-md-0", { active: this.state.tab === "2" })} onClick={() => { this.setState({ tab: "2" }); this.getWeek(this.state.weekStart); }} role="tab" href="#" >
                                    <i className="ni ni-calendar-grid-58 mr-2" />{translate['semana'] || "Semana"}
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </CardHeader>

                    <CardBody>
                        <TabContent activeTab={this.state.tab}>

                            {/* ------------------------- POR TURMA ------------------------- */}
                            <TabPane tabId="1">

                                <Row className="align-items-center mb-4">
                                    <Col md="6">
                                        <h5>{translate['turma'] || "Turma"}:</h5>
                                        <Input type="select" value={this.state.classroom} onChange={(event) => this.getCronograma(event.target.value)}>
                                            <option value="">{translate['selecione_a_turma'] || "Selecione a turma"}</option>
                                            {this.state.classrooms.map((classroom, index) => (
                                                <option key={index} value={classroom.id}>{classroom.name}</option>
                                            ))}
                                        </Input>
                                    </Col>
                                    <Col md="6" className="text-right">
                                        {(canManage && this.state.classroom !== "") &&
                                            <Button color="primary" onClick={() => this.setState({ openModalGenerate: true, erroGenerate: "", dialogGenerate: { lessons: "", startDate: "" } })}>
                                                <i className="fas fa-magic mr-2" />{translate['gerar_cronograma'] || "Gerar cronograma"}
                                            </Button>
                                        }
                                    </Col>
                                </Row>

                                {(this.state.classRoomData !== undefined) &&
                                    <Row className="mb-3">
                                        <Col>
                                            <small className="text-muted">
                                                {(this.state.classRoomData.dayOfTheWeek || []).map((day) => diasNome[parseInt(day)]).join(', ')}
                                                {' '}às {String(this.state.classRoomData.classTime || '').substring(0, 5)}
                                                {' '}| {translate['inicio'] || "Início"}: {moment(this.state.classRoomData.openingDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                            </small>
                                        </Col>
                                    </Row>
                                }

                                {(this.state.classroom !== "" && !this.state.loadSchedules) && <center><ClipLoader color="#adb5bd" size={30} /></center>}

                                {(this.state.classroom !== "" && this.state.loadSchedules && this.state.schedules.length === 0) &&
                                    <Alert color="secondary">{translate['nenhuma_aula_no_cronograma'] || "Nenhuma aula no cronograma dessa turma."} {canManage && (translate['clique_em_gerar'] || 'Clique em "Gerar cronograma" para criar as aulas automaticamente a partir dos dias e horário da turma.')}</Alert>
                                }

                                {(canManage && this.state.selected.length > 0) &&
                                    <Row className="mb-3">
                                        <Col>
                                            <Card className="bg-secondary shadow-none mb-0">
                                                <CardBody className="py-2 px-3">
                                                    <Row className="align-items-center">
                                                        <Col xs="12" md="6">
                                                            <strong>{this.state.selected.length}</strong>{' '}
                                                            {(this.state.selected.length === 1) ? (translate['aula_selecionada'] || "aula selecionada") : (translate['aulas_selecionadas'] || "aulas selecionadas")}
                                                        </Col>
                                                        <Col xs="12" md="6" className="text-md-right">
                                                            <Button size="sm" color="link" onClick={() => this.setState({ selected: [] })}>
                                                                {translate['limpar_selecao'] || "Limpar seleção"}
                                                            </Button>
                                                            <Button size="sm" color="danger" disabled={this.state.deleting} onClick={() => this.deleteSelected()}>
                                                                {this.state.deleting
                                                                    ? <ClipLoader color="#fff" size={13} />
                                                                    : <React.Fragment><i className="fas fa-trash mr-2" />{translate['remover_selecionadas'] || "Remover selecionadas"}</React.Fragment>
                                                                }
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                }

                                {(this.state.loadSchedules && this.state.schedules.length > 0) &&
                                    <Table className="align-items-center table-flush" responsive hover>
                                        <thead className="thead-light">
                                            <tr>
                                                {canManage &&
                                                    <th style={{ paddingLeft: "0px", paddingRight: "0px", width: "1px" }}>
                                                        <center>
                                                            <div className="custom-control custom-checkbox" style={{ width: "28px", paddingLeft: "58px", paddingRight: "0px" }}>
                                                                <input onChange={() => this.toggleSelectedAll()}
                                                                    checked={this.state.selected.length === this.state.schedules.length}
                                                                    className="custom-control-input" id="cronograma_check_all" type="checkbox" />
                                                                <label className="custom-control-label" htmlFor="cronograma_check_all" title={translate['selecionar_todas'] || "Selecionar todas"}></label>
                                                            </div>
                                                        </center>
                                                    </th>
                                                }
                                                <th>#</th>
                                                <th>{translate['data_da_aula'] || "Data"}</th>
                                                <th>{translate['dia'] || "Dia"}</th>
                                                <th>{translate['horario'] || "Horário"}</th>
                                                <th>{translate['status'] || "Status"}</th>
                                                <th>{translate['tema_objetivo'] || "Tema/objetivo"}</th>
                                                <th>{translate['presencas'] || "Presenças"}</th>
                                                <th className="text-right">{translate['acoes'] || "Ações"}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.schedules.map((schedule, index) => (
                                                <tr key={index} className={(this.state.selected.indexOf(schedule.id) !== -1) ? "table-warning" : ""}>
                                                    {canManage &&
                                                        <td style={{ paddingLeft: "0px", paddingRight: "0px", width: "1px" }}>
                                                            <center>
                                                                <div className="custom-control custom-checkbox" style={{ width: "28px", paddingLeft: "58px", paddingRight: "0px" }}>
                                                                    <input onChange={() => this.toggleSelected(schedule.id)}
                                                                        checked={this.state.selected.indexOf(schedule.id) !== -1}
                                                                        className="custom-control-input" id={"cronograma_check_" + schedule.id} type="checkbox" />
                                                                    <label className="custom-control-label" htmlFor={"cronograma_check_" + schedule.id}></label>
                                                                </div>
                                                            </center>
                                                        </td>
                                                    }
                                                    <td>{schedule.lessonNumber !== null ? schedule.lessonNumber : '—'}</td>
                                                    <td>
                                                        {moment(schedule.date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                                        {(schedule.originalDate !== null && schedule.originalDate !== undefined) &&
                                                            <small className="text-muted d-block"><s>{moment(schedule.originalDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</s></small>
                                                        }
                                                    </td>
                                                    <td>{diasNome[moment(schedule.date, 'YYYY-MM-DD').day()]}</td>
                                                    <td>{String(schedule.start_time || '').substring(0, 5)}</td>
                                                    <td><Badge color={statusColor[schedule.status] || "secondary"}>{schedule.status}</Badge></td>
                                                    <td style={{ maxWidth: "260px", whiteSpace: "normal" }}>{schedule.objective || <small className="text-muted">—</small>}</td>
                                                    <td>
                                                        {(parseInt(schedule.presentCount) + parseInt(schedule.absentCount) > 0)
                                                            ? <span><Badge color="success" pill>{schedule.presentCount} P</Badge>{' '}<Badge color="danger" pill>{schedule.absentCount} F</Badge></span>
                                                            : <small className="text-muted">—</small>
                                                        }
                                                    </td>
                                                    <td className="text-right">
                                                        {canManage &&
                                                            <React.Fragment>
                                                                <Button size="sm" color="secondary" title={translate['plano_de_aula'] || "Plano de aula"} onClick={() => this.setState({ openModalPlan: true, erroPlan: "", dialogPlan: Object.assign({}, schedule) })}>
                                                                    <i className="fas fa-edit" />
                                                                </Button>
                                                                <Button size="sm" color="warning" title={translate['remarcar'] || "Remarcar"} onClick={() => this.setState({ openModalReschedule: true, erroReschedule: "", reschedule: schedule, dialogReschedule: { date: schedule.date, cascade: true } })}>
                                                                    <i className="fas fa-calendar-alt" />
                                                                </Button>
                                                            </React.Fragment>
                                                        }
                                                        {!canManage &&
                                                            <Button size="sm" color="secondary" title={translate['plano_de_aula'] || "Plano de aula"} onClick={() => this.setState({ openModalPlan: true, erroPlan: "", dialogPlan: Object.assign({}, schedule) })}>
                                                                <i className="fas fa-eye" />
                                                            </Button>
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                }

                            </TabPane>

                            {/* ------------------------- SEMANA ------------------------- */}
                            <TabPane tabId="2">

                                <Row className="align-items-center mb-4">
                                    <Col md="4">
                                        <h5>{translate['semana_de'] || "Semana de"}:</h5>
                                        <InputGroup className="input-group-merge input-group-alternative">
                                            <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-calendar-grid-58" /></InputGroupText></InputGroupAddon>
                                            <ReactDatetime autoComplete="off" locale="pt-br" dateFormat="DD/MM/YYYY" timeFormat={false}
                                                value={moment(this.state.weekStart, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                                onChange={(event) => { try { this.getWeek(event.format('YYYY-MM-DD')); } catch (error) { } }} />
                                        </InputGroup>
                                        <small className="text-muted">{translate['mostra_7_dias'] || "Mostra as aulas de 7 dias a partir da data."}</small>
                                    </Col>
                                </Row>

                                {(!this.state.loadWeek) && <center><ClipLoader color="#adb5bd" size={30} /></center>}

                                {(this.state.loadWeek && this.state.weekSchedules.length === 0) &&
                                    <Alert color="secondary">{translate['nenhuma_aula_na_semana'] || "Nenhuma aula nessa semana."}</Alert>
                                }

                                {(this.state.loadWeek && this.state.weekSchedules.length > 0) &&
                                    <Table className="align-items-center table-flush" responsive hover>
                                        <thead className="thead-light">
                                            <tr>
                                                <th>{translate['data_da_aula'] || "Data"}</th>
                                                <th>{translate['dia'] || "Dia"}</th>
                                                <th>{translate['horario'] || "Horário"}</th>
                                                <th>{translate['turma'] || "Turma"}</th>
                                                <th>{translate['aula'] || "Aula"}</th>
                                                <th>{translate['status'] || "Status"}</th>
                                                <th>{translate['resumo_para_familias'] || "Resumo para as famílias"}</th>
                                                <th className="text-right">{translate['mensagem'] || "Mensagem"}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.weekSchedules.map((schedule, index) => (
                                                <tr key={index}>
                                                    <td>{moment(schedule.date, 'YYYY-MM-DD').format('DD/MM')}</td>
                                                    <td>{diasNome[moment(schedule.date, 'YYYY-MM-DD').day()]}</td>
                                                    <td>{String(schedule.start_time || '').substring(0, 5)}</td>
                                                    <td>{schedule.classRoomName}</td>
                                                    <td>{schedule.name}</td>
                                                    <td><Badge color={statusColor[schedule.status] || "secondary"}>{schedule.status}</Badge></td>
                                                    <td style={{ maxWidth: "300px", whiteSpace: "normal" }}>{schedule.familySummary || <small className="text-muted">—</small>}</td>
                                                    <td className="text-right">
                                                        <Button size="sm" color="secondary" title={translate['copiar_mensagem'] || "Copiar mensagem"} onClick={() => this.copyFamilyMessage(schedule)}>
                                                            <i className="fas fa-copy" />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                }

                            </TabPane>

                        </TabContent>
                    </CardBody>

                </Card>

            </Container>

            {/* ------------------------- MODAL GERAR ------------------------- */}
            <Modal className="modal-dialog-centered" isOpen={this.state.openModalGenerate} toggle={() => this.setState({ openModalGenerate: false })}>
                <div className="modal-header">
                    <h5 className="modal-title">{translate['gerar_cronograma'] || "Gerar cronograma"}</h5>
                    <button aria-label="Close" className="close" type="button" onClick={() => this.setState({ openModalGenerate: false })}><span aria-hidden={true}>×</span></button>
                </div>
                <div className="modal-body">
                    {(this.state.erroGenerate) && <Alert color="danger"><strong>{translate['ops'] || "Ops"}!</strong> {this.state.erroGenerate}</Alert>}
                    <p className="text-muted">{translate['gerar_cronograma_ajuda'] || "As datas são geradas a partir dos dias da semana e do horário da turma, pulando os feriados e recessos cadastrados."}</p>
                    <Form role="form" onSubmit={(event) => this.generateCronograma(event)}>
                        <Row>
                            <Col md="6">
                                <h5>{translate['numero_de_aulas'] || "Nº de aulas"}:</h5>
                                <FormGroup>
                                    <Input type="number" min="1" max="200" value={this.state.dialogGenerate.lessons} onChange={handleGenerate('lessons')} required />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <h5>{translate['data_da_primeira_aula'] || "1ª aula em (opcional)"}:</h5>
                                <FormGroup>
                                    <InputGroup className="input-group-merge input-group-alternative">
                                        <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-calendar-grid-58" /></InputGroupText></InputGroupAddon>
                                        <ReactDatetime autoComplete="off" locale="pt-br" dateFormat="DD/MM/YYYY" timeFormat={false}
                                            value={this.state.dialogGenerate.startDate !== "" ? moment(this.state.dialogGenerate.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : ""}
                                            inputProps={{ placeholder: translate['data_de_abertura_da_turma'] || "Data de abertura da turma" }}
                                            onChange={(event) => { var dialog = this.state.dialogGenerate; try { dialog.startDate = event.format('YYYY-MM-DD'); } catch (error) { dialog.startDate = ""; } this.setState({ dialogGenerate: dialog }); }} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <Button color="default" type="button" onClick={() => this.setState({ openModalGenerate: false })}>{translate['cancelar'] || "Cancelar"}</Button>
                            <Button color="primary" type="submit" disabled={this.state.generating}>
                                {this.state.generating ? <ClipLoader color="#fff" size={15} /> : (translate['gerar'] || "Gerar")}
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal>

            {/* ------------------------- MODAL PLANO DE AULA ------------------------- */}
            <Modal className="modal-dialog-centered" size="lg" isOpen={this.state.openModalPlan} toggle={() => this.setState({ openModalPlan: false })}>
                <div className="modal-header">
                    <h5 className="modal-title">{translate['plano_de_aula'] || "Plano de aula"} — {this.state.dialogPlan.name}</h5>
                    <button aria-label="Close" className="close" type="button" onClick={() => this.setState({ openModalPlan: false })}><span aria-hidden={true}>×</span></button>
                </div>
                <div className="modal-body">
                    {(this.state.erroPlan) && <Alert color="danger"><strong>{translate['ops'] || "Ops"}!</strong> {this.state.erroPlan}</Alert>}
                    <Form role="form" onSubmit={(event) => this.savePlan(event)}>
                        <Row>
                            <Col md="6">
                                <h5>{translate['nome'] || "Nome"}:</h5>
                                <FormGroup><Input type="text" value={this.state.dialogPlan.name || ""} onChange={handlePlan('name')} disabled={!canManage} /></FormGroup>
                            </Col>
                            <Col md="6">
                                <h5>{translate['status'] || "Status"}:</h5>
                                <FormGroup>
                                    <Input type="select" value={this.state.dialogPlan.status || "planejada"} onChange={handlePlan('status')} disabled={!canManage}>
                                        <option value="planejada">Planejada</option>
                                        <option value="realizada">Realizada</option>
                                        <option value="cancelada">Cancelada</option>
                                        <option value="remarcada">Remarcada</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <h5>{translate['tema_objetivo'] || "Tema/objetivo da aula"}:</h5>
                                <FormGroup><Input type="text" value={this.state.dialogPlan.objective || ""} onChange={handlePlan('objective')} disabled={!canManage} /></FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <h5>{translate['ferramenta'] || "Ferramenta"}:</h5>
                                <FormGroup><Input type="text" value={this.state.dialogPlan.tool || ""} onChange={handlePlan('tool')} disabled={!canManage} placeholder="Scratch, Construct, Python..." /></FormGroup>
                            </Col>
                            <Col md="6">
                                <h5>{translate['projeto'] || "Projeto"}:</h5>
                                <FormGroup><Input type="text" value={this.state.dialogPlan.project || ""} onChange={handlePlan('project')} disabled={!canManage} /></FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <h5>{translate['atividades'] || "Atividades"}:</h5>
                                <FormGroup><Input type="textarea" rows="2" value={this.state.dialogPlan.activities || ""} onChange={handlePlan('activities')} disabled={!canManage} /></FormGroup>
                            </Col>
                            <Col md="6">
                                <h5>{translate['atividade_de_casa'] || "Atividade de casa"}:</h5>
                                <FormGroup><Input type="textarea" rows="2" value={this.state.dialogPlan.homework || ""} onChange={handlePlan('homework')} disabled={!canManage} /></FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <h5>{translate['resumo_para_familias'] || "Resumo para as famílias"}:</h5>
                                <FormGroup><Input type="textarea" rows="2" value={this.state.dialogPlan.familySummary || ""} onChange={handlePlan('familySummary')} disabled={!canManage} placeholder={translate['resumo_familias_ajuda'] || "Texto curto que a unidade envia aos responsáveis sobre o que foi visto na aula."} /></FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <h5>{translate['observacoes'] || "Observações"}:</h5>
                                <FormGroup><Input type="textarea" rows="2" value={this.state.dialogPlan.notes || ""} onChange={handlePlan('notes')} disabled={!canManage} /></FormGroup>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <Button color="default" type="button" onClick={() => this.setState({ openModalPlan: false })}>{canManage ? (translate['cancelar'] || "Cancelar") : (translate['fechar'] || "Fechar")}</Button>
                            {canManage && <Button color="primary" type="submit">{translate['salvar'] || "Salvar"}</Button>}
                        </div>
                    </Form>
                </div>
            </Modal>

            {/* ------------------------- MODAL REMARCAR ------------------------- */}
            <Modal className="modal-dialog-centered" isOpen={this.state.openModalReschedule} toggle={() => this.setState({ openModalReschedule: false })}>
                <div className="modal-header">
                    <h5 className="modal-title">{translate['remarcar_aula'] || "Remarcar aula"} — {(this.state.reschedule !== undefined) ? this.state.reschedule.name : ""}</h5>
                    <button aria-label="Close" className="close" type="button" onClick={() => this.setState({ openModalReschedule: false })}><span aria-hidden={true}>×</span></button>
                </div>
                <div className="modal-body">
                    {(this.state.erroReschedule) && <Alert color="danger"><strong>{translate['ops'] || "Ops"}!</strong> {this.state.erroReschedule}</Alert>}
                    <Form role="form" onSubmit={(event) => this.saveReschedule(event)}>
                        <h5>{translate['nova_data'] || "Nova data"}:</h5>
                        <FormGroup>
                            <InputGroup className="input-group-merge input-group-alternative">
                                <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-calendar-grid-58" /></InputGroupText></InputGroupAddon>
                                <ReactDatetime autoComplete="off" locale="pt-br" dateFormat="DD/MM/YYYY" timeFormat={false}
                                    value={this.state.dialogReschedule.date !== "" ? moment(this.state.dialogReschedule.date, 'YYYY-MM-DD').format('DD/MM/YYYY') : ""}
                                    onChange={(event) => { var dialog = this.state.dialogReschedule; try { dialog.date = event.format('YYYY-MM-DD'); } catch (error) { } this.setState({ dialogReschedule: dialog }); }} />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup check className="mb-3">
                            <label className="form-check-label">
                                <Input type="checkbox" checked={this.state.dialogReschedule.cascade} onChange={(event) => { var dialog = this.state.dialogReschedule; dialog.cascade = event.target.checked; this.setState({ dialogReschedule: dialog }); }} />
                                {translate['reajustar_proximas_aulas'] || "Reajustar as próximas aulas planejadas a partir da nova data (pula feriados)"}
                            </label>
                        </FormGroup>
                        <div className="text-center">
                            <Button color="default" type="button" onClick={() => this.setState({ openModalReschedule: false })}>{translate['cancelar'] || "Cancelar"}</Button>
                            <Button color="warning" type="submit">{translate['remarcar'] || "Remarcar"}</Button>
                        </div>
                    </Form>
                </div>
            </Modal>

        </React.Fragment>)

    }

}

export default connect(state => ({

    languages: state.language,
    translate: state.translate,
    accesslevel: state.accesslevel,
    permission: state.permission,
    user: state.user,

}))(Cronograma);
